export default "__VITE_ASSET__8c991bd8__"